import React from "react";

import { Container } from "./styles";

const Link = ({ children, ...props }) => (
  <Container {...props}>{children}</Container>
);

export default Link;
